import { url } from 'components/Footer/constants';
import Styles from 'components/SideBarMenu/styles';
import Image from 'next/image';
const { SideBarLanguageSelector, TextContainer } = Styles;

const MenuFooter = () => {
	return (
		<SideBarLanguageSelector href="/resources/select-location">
			<Image className="flag" width={12} height={9} src={`${url}/content/dam/royal/resources/icons/flags/USA.svg`} alt="USA" unoptimized={true} />
			<TextContainer>UNITED STATES</TextContainer>
		</SideBarLanguageSelector>
	);
};
MenuFooter.propTypes = {};

export default MenuFooter;
